import React from 'react';

import { OfferOption, SelectedExtendedOffer } from '@utils/backend-api/subscribe';

import ChoosePlanHeader from './ChoosePlanHeader';
import CorporateInquiry from './CorporateInquiry';
import MultipleOffers from './MultipleOffers';
import SignupForm from './SignupForm';

interface OfferSelectionProps {
  description?: string;
  offers: OfferOption[];
  onOfferSelect: () => void;
  selectedOffer?: SelectedExtendedOffer;
  setSelectedOffer: (offer: SelectedExtendedOffer) => void;
}

const OfferSelection = ({
  description,
  offers,
  onOfferSelect,
  selectedOffer,
  setSelectedOffer,
}: OfferSelectionProps) => {
  return (
    <div className="px-16 pb-80 pt-32 sm:px-28 sm:pb-96 sm:pt-48 lg:pb-112 lg:pt-64">
      <div className="mx-auto max-w-full sm:max-w-[712px] md:max-w-[1040px]">
        <ChoosePlanHeader description={description} />
        <SignupForm
          formLocation={'subscribe_h'}
          presentedOfferCodes={offers.map((offer) => offer.code)}
          selectedOffer={selectedOffer}
        />
        <MultipleOffers
          offers={offers}
          onOfferSelect={onOfferSelect}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
        />
      </div>
      <CorporateInquiry />
    </div>
  );
};

export default OfferSelection;
